import {BrowserCacheLocation, PublicClientApplication} from '@azure/msal-browser'
import type { Configuration } from '@azure/msal-browser'

const authority = import.meta.env.VITE_OIDC_AUTHORITY || import.meta.env.VITE_OICD_AUTHORITY;
const clientId = import.meta.env.VITE_OIDC_CLIENTID || import.meta.env.VITE_OICD_CLIENTID;

const { protocol, host } = window.location;
const redirectUri = `${protocol}//${host}${import.meta.env.BASE_URL}redirect.html`;
export const signedOutRedirectUri = `${protocol}//${host}${import.meta.env.BASE_URL}signed-out`;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri,
    postLogoutRedirectUri: signedOutRedirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

export const tokenRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};
